import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./PaymentStatus.css"; // Crea un CSS compartido

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  // Capturamos el ID de pago de la URL por si quieres mostrarlo
  const paymentId = searchParams.get("payment_id");

  return (
    <div className="status-container success">
      <div className="status-card">
        <div className="status-icon">✅</div>
        <h1>¡Pago Exitoso!</h1>
        <p>Gracias por tu compra en <strong>FIORI</strong>.</p>
        {paymentId && <p className="payment-ref">Referencia: {paymentId}</p>}
        <p>Pronto recibirás un correo con los detalles de tu pedido.</p>
        
        <button className="status-btn" onClick={() => navigate("/")}>
          Volver al Menú de Productos
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccess;